import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import farmy from "../../Assets/Projects/farmy.jpg";
import hospitalManagement from "../../Assets/Projects/hospital.jpg";
import LMS from "../../Assets/Projects/lms.png";
import nsbmSports from "../../Assets/Projects/nsbm-sports.jpeg";
import ASP from "../../Assets/Projects/homepage.jpg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Projects </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={LMS}
              isBlog={false}
              title="Learning Management System"
              description="Through our mobile app, students and lecturers at the university can do their work more easily. Using our mobile application, and students can easily access their course-related modules, study materials, schedule, and exam marks. Students can log into the system using their username and password. The student's information can be viewed in the user detail account. We created a slide navigation bar in our mobile app to navigate each activity"
              ghLink="https://github.com/ravindu0823/Learning-management-system"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ASP}
              isBlog={false}
              title="Waste Management System"
              description="This is a web application for Garbage Management System. This application is developed using ASP .NET Framework and C# programming language. This application is developed for clean garbage areas in sri lanka"
              ghLink="https://github.com/ravindu0823/ASP-.NET-Web-Application"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={hospitalManagement}
              isBlog={false}
              title="Hospital Management System"
              description="We developed this software to make the work in a hospital more efficient. And to manage the hospital. We used C # language to create this software and the .NET framework and Guna UI framework. This software has 7 primary user interfaces. These interfaces allow you to enter and manage the details of the doctors, manage the records of the patients, make appointments to see a doctor, manage hospital rooms, pay hospital fees, and manage the hospital's pharmacy. A lot can be done."
              ghLink="https://github.com/ravindu0823/C-Sharp-Group-Project"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={farmy}
              isBlog={false}
              title="Plant Disease Classifier"
              description="Like humans, plants also get diseases. There are many methods in the world to identify diseases. This is also a solution for that. It's a plant disease classifier. The outcome of the project is to identify diseases of the plants. (Leaves, trunk, bark, root, branches) We hope to develop a mobile application for any user who knows or doesn't know about diseases to identify them from anywhere in the world quickly."
              ghLink="https://github.com/ravindu0823/Computing-Group-Project/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={nsbmSports}
              isBlog={false}
              title="NSBM Sports"
              description="Developed a Website for manage the sports clubs."
              ghLink="https://github.com/ravindu0823/WEB-Project"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
